import PropTypes from "prop-types";

// Layouts
import TimePicker from "@Layouts/components/TimePicker";

// MUI
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { DATE_FORMAT } from "@/Constants/date";

export default function TimePickerRange(props) {
	const { nightShiftPay, loading, readOnly, fromInputError, toInputError, onSwitchChange = () => {}, onUpdateTime = () => {} } = props;

	return (
		<Stack direction={"row"} spacing={2} alignItems={"center"}>
			<TimePicker
				defaultDate={nightShiftPay?.from}
				error={fromInputError}
				inputFormat={DATE_FORMAT.time12h}
				placement={"bottom-end"}
				sx={{ maxWidth: "125px" }}
				onAccept={(data) => onUpdateTime(data, "from")}
				onActionUpdate={(data) => onUpdateTime(data, "from")}
				isHoursAndMinutesOnly={true}
				ampm={true}
				disabled={readOnly || loading}
			/>
			<Typography className="small-label">to</Typography>
			<TimePicker
				defaultDate={nightShiftPay?.to}
				error={toInputError}
				inputFormat={DATE_FORMAT.time12h}
				placement={"bottom-end"}
				sx={{ maxWidth: "125px" }}
				onAccept={(data) => onUpdateTime(data, "to")}
				onActionUpdate={(data) => onUpdateTime(data, "to")}
				isHoursAndMinutesOnly={true}
				ampm={true}
				disabled={readOnly || loading}
			/>
			<FormControlLabel
				control={
					<Checkbox
						checked={nightShiftPay?.isMultipleDays}
						onChange={() => onSwitchChange?.("isMultipleDays", !nightShiftPay?.isMultipleDays)}
					/>
				}
				label={<Typography className="checkbox-text">{"+1 day"}</Typography>}
				labelPlacement="end"
				disabled={readOnly || loading}
			/>
		</Stack>
	);
}
TimePickerRange.propTypes = {
	nightShiftPay: PropTypes.shape({
		from: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		isMultipleDays: PropTypes.bool,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	fromInputError: PropTypes.bool,
	toInputError: PropTypes.bool,
	onUpdateTime: PropTypes.func,
	onSwitchChange: PropTypes.func,
};
